import React from 'react';

import ActionBox from '../../../components/TableGrid/TableGridToolbar/ActionBox/ActionBox';
import { ActionLink } from '../../../components/TableGrid/TableGridToolbar/ActionBox/ActionBox.type';

interface ResetBoxProps {
  onResetCompIDAIReport: () => Promise<void>;
}

const ResetBox: React.FC<ResetBoxProps> = ({ onResetCompIDAIReport }) => {
  const actionItems: ActionLink[] = [
    {
      title: 'benchmark:action.resetStudy',
      onClick: onResetCompIDAIReport,
      isNotActive: false,
      isHidden: false,
    },
  ];

  return <ActionBox buttonTitle="Reset" actionItems={actionItems} />;
};

export default ResetBox;
